// Hook usuniecia calej kalkulacji -
// DELETE /sales-crm/clients/:cid/offers/:oid/calculations/:calcId

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

const deleteSalesCrmOfferCalculation = (
  clientId: number,
  offerId: string,
  calculationId: number
): Promise<ICommandResponseSuccess> =>
  axios.delete(
    `/sales-crm/clients/${clientId}/offers/${offerId}/calculations/${calculationId}`
  );

export const useDeleteSalesCrmOfferCalculation = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<ICommandResponseSuccess, IError, number>
) =>
  useMutation(
    (calculationId: number) =>
      deleteSalesCrmOfferCalculation(clientId, offerId, calculationId),
    options
  );
